import * as React from 'react'
import { BulkReassignForm } from '@user/components/xGrid'
import { ENTITY_TYPES } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { bulkReassignLeads } from '@user/store/lead'
import { BulkReassignInput } from '@user/components/xGrid/atoms/BulkActions/typings/BulkReassign'

export const BulkReassignLeads: React.FC = () => {
  const dispatch = useAppDispatch()

  const validateRows = React.useCallback(
    async (model: BulkReassignInput) => {
      const response = await dispatch(bulkReassignLeads({ model }))
      if (bulkReassignLeads.fulfilled.match(response))
        return response.payload.model
    },
    [dispatch],
  )

  const onSubmit = React.useCallback(
    async (model: BulkReassignInput) =>
      void (await dispatch(bulkReassignLeads({ model, mode: 'commit' }))),
    [dispatch],
  )

  return (
    <BulkReassignForm
      entityType={ENTITY_TYPES.Lead}
      onSubmit={onSubmit}
      validateRows={validateRows}
    />
  )
}
BulkReassignLeads.displayName = 'BulkReassignLeads'
